import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  button: {
    ...theme.standarts('button'),

    backgroundColor: 'transparent',
    transition: 'color 0.2s linear, background-color 0.2s linear',

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderStyle: 'none',
    borderWidth: theme.get('button', 'border.width'),
    borderRadius: theme.get('button', 'border.radius'),
    margin: 0,
    paddingLeft: theme.getFactor('button', 'indent', 3),
    paddingRight: theme.getFactor('button', 'indent', 3),
    paddingTop: theme.get('button', 'indent'),
    paddingBottom: theme.get('button', 'indent'),
    gap: theme.get('button', 'indent'),

    position: 'relative',

    '&:disabled': {
      color: theme.getColor('button', 'disabled', 'value'),

      cursor: 'default'
    }
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  text: {
    color: theme.getColor('button', color, 'value')
  },

  contained: {
    backgroundColor: theme.getColor('button', color, 'value'),
    color: theme.getColor('button', color, 'contrast'),

    borderStyle: theme.get('button', 'border.style'),
    borderColor: theme.getColor('button', color, 'value'),

    '&:hover': {
      backgroundColor: theme.getColor('button', color, 'contrast'),
      color: theme.getColor('button', color, 'value')
    },

    '&:disabled': {
      backgroundColor: theme.getColor('button', 'disabled', 'contrast'),
      color: theme.getColor('button', 'disabled', 'value'),

      borderColor: theme.getColor('button', 'disabled', 'value')
    }
  },

  outlined: {
    backgroundColor: theme.getColor('button', color, 'contrast'),
    color: theme.getColor('button', color, 'value'),

    borderStyle: theme.get('button', 'border.style'),
    borderColor: theme.getColor('button', color, 'value'),

    '&:hover': {
      backgroundColor: theme.getColor('button', color, 'value'),
      color: theme.getColor('button', color, 'contrast')
    },

    '&:disabled': {
      backgroundColor: theme.getColor('button', 'disabled', 'value'),
      color: theme.getColor('button', 'disabled', 'contrast'),

      borderColor: theme.getColor('button', 'disabled', 'value')
    }
  },
  
  icon: {
    backgroundColor: 'transparent',
    color: theme.getColor('button', color, 'value'),
    
    borderRadius: '50%',
    margin: theme.getFactor('button', 'indent', -0.5),
    padding: theme.getFactor('button', 'indent', 0.5),
    
    '&:hover': {
      backgroundColor: theme.getColor('button', color, 'value', null, null, null, 0.1),
      color: theme.getColor('button', color, 'contrast')
    },
    
    '&:active': {
      backgroundColor: theme.getColor('button', color, 'value', null, null, null, 0.3)
    },

    '&:disabled': {
      color: theme.getColor('button', 'disabled', 'value')
    }
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap
      }
    };

    static propTypes = {
      variant: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    };

    static defaultProps = {
      variant: 'text',
      color: 'primary'
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        classes,
        className,
        children,
        variant,
        color,
        ...props
      } = this.props;

      const mergedClassName = mergeClassName(
        className,
        classes.main.button,
        (classes.variant[color] ?? classes.variant.basic)[variant]
      );

      return (
        <button {...props} className={mergedClassName}>
          {children}
        </button>
      );
    }
  }
);
